export default function getCharge(batteryVoltage: number) {
    const maxVoltage = 3.1;
    return Math.ceil((batteryVoltage / maxVoltage) * 100);
}
